import { createUseStyles } from "react-jss";

export default createUseStyles({
    imageAreaSelection: {
        composes: "image-area__selection",
        content: "",
        cursor: "pointer",
        display: "inline-block",
        lineHeight: 0,
        maxWidth: "100%",
        opacity: "1",
        position: "absolute",
        transition: "background 200ms, opacity 200ms",
        width: "10px",
        height: "10px",
        borderRadius: "50%",
        boxShadow: "0 6px 12px rgba(0,0,0,.175)",
        background: "white !important",
    },
    imageAreaSelectionActive: {
        background: "#999",
        composes: "image-area__selection--active",
    },
});
